import { en, type Key } from "./i18n";
import type { Alert, Overview } from "./types";

/** "ONT offline" for a known metric, else the alert's own message, else the raw metric. */
export function incidentTitle(t: (k: Key) => string, a: Pick<Alert, "metric" | "message">): string {
  const key = `incident.${a.metric}`;
  return key in en ? t(key as Key) : a.message ?? a.metric;
}

/** Who the alert is about: customer label, the OLT's name, else "olt #2". */
export function incidentTarget(
  a: Pick<Alert, "target_type" | "target_id" | "target_label">,
  olts: Overview["olts"],
): string {
  if (a.target_label) return a.target_label;
  if (a.target_type === "olt") {
    const o = olts.find((x) => x.id === a.target_id);
    if (o) return o.name;
  }
  return `${a.target_type} #${a.target_id}`;
}
